import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchShortlistsMine, fetchShortlistsReceived, fetchNotifications, markNotificationAsRead } from "../services/shortListService";
import { logout } from "./authSlice";
// Async thunk to fetch shortlists for a user
export const fetchUserShortlistsMine = createAsyncThunk(
  "shortList/fetchUserShortlistsMine",
    async (thunkAPI) => {
      return fetchShortlistsMine();
    }
);

// fetch shortlist recived to me
export const fetchUserShortlistsReceived = createAsyncThunk(
  "shortList/fetchUserShortlistsReceived",
  async (thunkAPI) => {
    return fetchShortlistsReceived();
  }
);


//get all notifications for a user
export const fetchUserNotifications = createAsyncThunk(
  "shortList/fetchUserNotifications",
  async (userId, thunkAPI) => {
    return fetchNotifications(userId);
  }
);

//mark read notfication
export const markNotification = createAsyncThunk(
  "shortList/markNotificationAsRead",
  async (notificationId, thunkAPI) => {
    return markNotificationAsRead(notificationId);
  }
);


const shortListSlice = createSlice({
  name: "shortList",
  initialState: {
    shortlistsMine: [],
    shortlistsReceived: [],
    notifications: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserShortlistsMine.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserShortlistsMine.fulfilled, (state, action) => {
        state.loading = false;
        state.shortlistsMine = action.payload;
      })
      .addCase(fetchUserShortlistsMine.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchUserNotifications.fulfilled, (state, action) => {
        state.notifications = action.payload;
      })
      .addCase(markNotification.fulfilled, (state, action) => {
        const updatedNotification = action.payload;
      }).addCase(markNotification.rejected, (state, action) => {
        console.error("Failed to mark notification as read:", action.error.message);
      }).addCase(fetchUserShortlistsReceived.fulfilled, (state, action) => {
        state.shortlistsReceived = action.payload;
      }).addCase(logout, (state) => {
        console.log("🔥 LOGOUT TRIGGERED IN SHORTLIST SLICE");

        state.shortlistsMine = [];
        state.shortlistsReceived = [];
        state.notifications = [];
        state.loading = false;
        state.error = null;
  });
}
});

export default shortListSlice.reducer;